"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ImageComponent = _interopRequireDefault(require("./ImageComponent"));

function VideoComponent(_ref) {
  var active = _ref.active,
      alt = _ref.alt,
      mediaSizeMap = _ref.mediaSizeMap,
      size = _ref.size,
      src = _ref.src,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["active", "alt", "mediaSizeMap", "size", "src"]);
  return !active ? /*#__PURE__*/_react.default.createElement(_ImageComponent.default, (0, _extends2.default)({}, rest, {
    alt: alt,
    size: size,
    src: src
  })) : 'Video';
}

process.env.NODE_ENV !== "production" ? VideoComponent.propTypes = {
  active: _propTypes.default.bool,
  alt: _propTypes.default.string,
  mediaSizeMap: _propTypes.default.shape({}),
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired,
  src: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.string))]).isRequired
} : void 0;
VideoComponent.defaultProps = {
  active: false,
  alt: undefined,
  mediaSizeMap: undefined
};
var _default = VideoComponent;
exports.default = _default;